import type { TFunction } from 'i18next';
import type { BoardVersion } from '../../lib/version-types';

/** What a version is called in the history: its label, or its kind. */
export function versionTitle(v: BoardVersion, t: TFunction): string {
  if (v.kind === 'manual') return v.label ?? '';
  return v.kind === 'auto' ? t('history.auto') : t('history.preRestore');
}

/** Versions by local day, in the order given (newest first). */
export function groupByDay(versions: readonly BoardVersion[], locale: string): { day: string; items: BoardVersion[] }[] {
  const fmt = new Intl.DateTimeFormat(locale, { dateStyle: 'full' });
  const groups: { day: string; items: BoardVersion[] }[] = [];
  for (const v of versions) {
    const day = fmt.format(new Date(v.createdAt));
    const last = groups.at(-1);
    if (last?.day === day) last.items.push(v);
    else groups.push({ day, items: [v] });
  }
  return groups;
}
